// src/App.js
import React from "react";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider } from "./contexts/AuthContext.js";
import { ProtectedRoute } from "./components/ProtectedRoute.js";
import NavBar from "./components/NavBar.js";
import Footer from "./components/Footer.js";
import ScrollToTop from "./components/ScrollToTop.js";
 import ChatWidget from "./components/ChatWidget.js"; // hidden until a working OpenAI key is added

// Pages
import Home from "./pages/Home.js";
import SportsHandoff from "./pages/SportsHandoff.js";
import Article from "./pages/Article.js";
import AdminArticles from "./pages/admin/AdminArticles.js";
import AdminDashboard from "./pages/admin/AdminDashboard.js";
import AdminEdit from "./pages/admin/AdminEdit.js";
import AdminAddUser from "./pages/admin/AdminAddUser.js";
import ArticlePortal from "./pages/ArticlePortal.js";
import AdminProfile from "./pages/admin/AdminProfile.js";
import AdminPricing from "./pages/admin/AdminPricing.js";
import JournalHome from "./pages/journal/JournalHome.js";
import JournalDB from "./pages/journal/JournalDB.js";
import ReportHome from "./pages/reporter/ReportHome.js";
import ReportDB from "./pages/reporter/ReportDB.js";
import Profile from "./pages/user/Profile.js";
import Settings from "./pages/user/Settings.js";
import Login from "./pages/Login.js";
import Signup from "./pages/Signup.js";
import Subscribe from "./pages/Subscribe.js";
import Unauthorized from "./pages/Unauthorized.js";
import CategoryPage from "./pages/CategoryPage.js";
import Pricing from "./pages/Pricing.js";
import PaymentPolicy from "./pages/PaymentPolicy.js";
import RefundPolicy from "./pages/RefundPolicy.js";
import PrivacyPolicy from "./pages/PrivacyPolicy.js";
import TermsOfService from "./pages/TermsOfService.js";

function App() {
  return (
    <AuthProvider>
      <Router>
        <ScrollToTop />
        <div style={{ display: "flex", flexDirection: "column", minHeight: "100vh" }}>
          <NavBar />

          <div style={{ flex: 1 }}>
            <Routes>
              {/* Public / general pages */}
              <Route path="/" element={<Home />} />
              <Route path="/sso/vyralsports" element={<SportsHandoff />} />
              <Route path="/category/:category" element={<CategoryPage />} />
              <Route path="/category/:category/:subcategory" element={<CategoryPage />} />
              <Route path="/article/:id" element={<Article />} />
              <Route path="/login" element={<Login />} />
              <Route path="/signup" element={<Signup />} />
              <Route path="/subscribe" element={<Subscribe />} />
              <Route path="/unauthorized" element={<Unauthorized />} />
              <Route path="/pricing" element={<Pricing />} />
              <Route path="/payment-policy" element={<PaymentPolicy />} />
              <Route path="/refund-policy" element={<RefundPolicy />} />
              <Route path="/privacy" element={<PrivacyPolicy />} />
              <Route path="/terms" element={<TermsOfService />} />

              {/* Admin-only */}
              <Route
                path="/admin/dashboard"
                element={
                  <ProtectedRoute allowedRoles={["admin"]}>
                    <AdminDashboard />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/admin/profile"
                element={
                  <ProtectedRoute allowedRoles={["admin"]}>
                    <AdminProfile />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/admin/users/add"
                element={
                  <ProtectedRoute allowedRoles={["admin"]}>
                    <AdminAddUser />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/admin/users/edit/:id"
                element={
                  <ProtectedRoute allowedRoles={["admin"]}>
                    <AdminEdit />
                  </ProtectedRoute>
                }
              />

              <Route
                path="/admin/articles"
                element={
                  <ProtectedRoute allowedRoles={["admin"]}>
                    <AdminArticles />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/admin/pricing"
                element={
                  <ProtectedRoute allowedRoles={["admin"]}>
                    <AdminPricing />
                  </ProtectedRoute>
                }
              />

              {/* Article portal — for admin, journalist, reporter */}
              <Route
                path="/portal/articles"
                element={
                  <ProtectedRoute allowedRoles={["admin","journalist","reporter"]}>
                    <ArticlePortal />
                  </ProtectedRoute>
                }
              />

              {/* Journalist / Reporter / User / etc */}
              <Route
                path="/journal/home"
                element={
                  <ProtectedRoute allowedRoles={["admin", "journalist"]}>
                    <JournalHome />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/journal/db"
                element={
                  <ProtectedRoute allowedRoles={["admin", "journalist"]}>
                    <JournalDB />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/report/home"
                element={
                  <ProtectedRoute allowedRoles={["admin", "reporter"]}>
                    <ReportHome />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/report/db"
                element={
                  <ProtectedRoute allowedRoles={["admin", "reporter"]}>
                    <ReportDB />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/user/profile"
                element={
                  <ProtectedRoute allowedRoles={["admin","user","journalist","reporter","freemium"]}>
                    <Profile />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/user/settings"
                element={
                  <ProtectedRoute allowedRoles={["admin","user","journalist","reporter","freemium"]}>
                    <Settings />
                  </ProtectedRoute>
                }
              />

              {/* Catch-all */}
              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
          </div>

          <Footer />
          <ChatWidget />
        </div>
      </Router>
    </AuthProvider>
  );
}

export default App;
